var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7143 0H1.28571C0.944826 0.000340378 0.617997 0.135908 0.376953 0.376953C0.135908 0.617997 0.000340378 0.944826 0 1.28571V16.7143C0.000340378 17.0552 0.135908 17.382 0.376953 17.623C0.617997 17.8641 0.944826 17.9997 1.28571 18H16.7143C17.0552 17.9997 17.382 17.8641 17.623 17.623C17.8641 17.382 17.9997 17.0552 18 16.7143V1.28571C17.9997 0.944826 17.8641 0.617997 17.623 0.376953C17.382 0.135908 17.0552 0.000340378 16.7143 0ZM16.7143 7.71429H13.5V1.28571H16.7143V7.71429ZM9 1.28571H12.2143V7.71429H9V1.28571ZM7.71429 1.28571V11.5714H1.28571V1.28571H7.71429ZM1.28571 12.8571H7.71429V16.7143H1.28571V12.8571ZM9 16.7143V9H16.7143V16.7143H9Z",
    fill: "#919191"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarm);
export default __webpack_public_path__ + "static/media/farm.56fcded2906b545737f9f82e0baa6e36.svg";
export { ForwardRef as ReactComponent };